import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _OnClickActionsMap;
import { HOW_TO_SELL_CAR_WIDGET_CTA_NAME, SELL_YOUR_CAR_CTA_NAME } from "../../../Constants/templateName";
var OnClickActionsMap = (_OnClickActionsMap = {}, _defineProperty(_OnClickActionsMap, HOW_TO_SELL_CAR_WIDGET_CTA_NAME, 'quoteNowAction'), _defineProperty(_OnClickActionsMap, SELL_YOUR_CAR_CTA_NAME, 'scrollnClickCtaAction'), _OnClickActionsMap);
export default OnClickActionsMap;